module.exports = __webpack_public_path__ + "static/media/10d.5bfccfa8.svg";